export const DROPDOWN_MENU_TYPES = {
  DEFAULT: 'default',
  DEFAULT_NEXT: 'default-next'
}
